import { FIXED2 } from "../../tools/fixedTools";



function findTaxDataFromBankTransactionEcritureLine(bankTransaction, ecritureLine) {

  const tax = {
    id: "",
    label: "",
    valuePourcent: 0,
    mode: "",
    valueHT: 0 
  }

  // console.log("14 - bankTransaction=", bankTransaction);
  // console.log("15 - ecritureLine=", ecritureLine);

  const ratio = bankTransaction.companyCurrencyAmount / bankTransaction.amount
  const lookingFor = Math.abs(FIXED2(ecritureLine.amount / ratio));

  // console.log("20 - lookingFor=", lookingFor);

  for (const line of bankTransaction.bankTransactionLines) {
    for (const taxPiece of line.taxPieces) {

      if (Math.abs(Math.abs(taxPiece.amount) - lookingFor) <= 0.1) {
        
        tax.id = taxPiece.tax.id;
        tax.label = taxPiece.tax.label;
        tax.valuePourcent = taxPiece.tax.valuePourcent;
        tax.mode = taxPiece.tax.mode;
        tax.valueHT = FIXED2(line.valueHT * ratio);
        return tax;
      }
    }
  }
  return tax;
}


const ChartsTaxesDataCompute = (props, edges) => {

  if (edges) {
    let data = [];

    // const item = {
    //   category: edges[0].node.category
    // };

    // data.push(item);
    // console.log("14 - edges=", edges);

    const invoiceEcritureLinesDoneArray = new Array();
    const expenseEcritureLinesDoneArray = new Array();
    const bankTransactionEcritureLinesDoneArray = new Array();

    for (const element of edges) {
      // console.log("item=", element.node);

      if (element.node.invoice) {

        // console.log("*************************************************");
        // console.log("item invoice=", element.node.invoice);

        const mapItems = new Map();

        let dateLettrage = element.node.dateLettrage;
        for (const ecritureLine of element.node.invoice.ecritureLines) {
          if (ecritureLine.dateLettrage !== null)
            dateLettrage = ecritureLine.dateLettrage;
        }

        if (dateLettrage !== null) {

          let acompteBaseHT = 0;
          for (const ecritureLine of element.node.invoice.ecritureLines) {

            // console.log("40 - ecritureLine.id)=", ecritureLine.id);
            // console.log("41 - invoiceEcritureLinesDoneArray=", invoiceEcritureLinesDoneArray);
            if (invoiceEcritureLinesDoneArray.includes(ecritureLine.id))
              continue;

            // console.log("44 - ecritureLine=", ecritureLine);
            invoiceEcritureLinesDoneArray.push(ecritureLine.id);

            if (
              ecritureLine.category.ids === "ids_taxesDeductiblesSurBiensEtServices" ||
              ecritureLine.category.ids === "ids_taxesSurVentes"
            ) {

              // console.log(" => cat (taxes)=", ecritureLine.category.ids);
              const item = {
                id: ecritureLine.id,
                taxLabel: "",
                taxTaux: 0,
                taxType: "ENCAISSEMENT",
                // date: null,
                paymentDate: null,
                operationDate: null,
                baseHT: 0.0,
                amount: 0.0,
                invoiceId: null,
                expenseId: null,
                bankTransactionId: null,
                category: null,
                tiers: null
              };
              const taxTxt =
                ecritureLine.taxes[0].label +
                "%" +
                ecritureLine.taxes[0].valuePourcent;
              let savedItem = mapItems.get(taxTxt);

              item.invoiceId = element.node.invoice.id;
              item.tiers = element.node.invoice.tiersClient;

              if (savedItem === undefined) {

                item.taxLabel = ecritureLine.taxes[0].label;
                item.taxTaux = ecritureLine.taxes[0].valuePourcent;
                item.taxType = ecritureLine.taxes[0].mode;
                item.amount = FIXED2(ecritureLine.amount * -1);
                item.category = ecritureLine.category;

                if (acompteBaseHT !== 0) {      // since acompte has no tax info in NW1
                  item.baseHT = acompteBaseHT;
                  acompteBaseHT = 0;
                }
                // if (
                //   ecritureLine.taxes[0].mode === "DEBIT" ||
                //   element.node.dateLettrage === null
                // ) {
                //   item.date = element.node.dateOperation;
                // } else {
                //   item.date = element.node.dateLettrage;
                // }

                item.paymentDate = dateLettrage;
                item.operationDate = element.node.dateOperation;

              } else {

                item.taxLabel = savedItem.taxLabel;
                item.taxTaux = savedItem.taxTaux;
                item.taxType = savedItem.taxType;
                // item.date = savedItem.date;
                item.paymentDate = savedItem.paymentDate;
                item.operationDate = savedItem.operationDate;
                item.baseHT = savedItem.baseHT;
                item.invoiceId = savedItem.invoiceId;
                item.expenseId = savedItem.expenseId;
                item.bankTransactionId = savedItem.bankTransactionId;
                item.category = savedItem.category;

                item.amount = savedItem.amount + FIXED2(ecritureLine.amount * -1);
              }
              // console.log(" =>    taxTxt(1)=", taxTxt, item);
              mapItems.set(taxTxt, item);

            } else {

              // console.log(" => cat (other)=", ecritureLine.category.ids);

              // // console.log("ecritureLine.taxes=", ecritureLine.taxes);
              // if (ecritureLine.taxes.length === 0) {
              //   console.log(" =>    NO TAXES", ecritureLine);
              // }

              const mapMissingTax = new Map();
              for (const tax of element.node.company.taxes) {

                if (tax.active) {
                  const atom = {
                    label: tax.label,
                    mode: tax.mode,
                    missing: 1
                  }
                  mapMissingTax.set(tax.label, atom);
                }
              }
              let commonBaseHT = 0.0;

              // console.log("144= -------------------------------------------");
              for (const tax of ecritureLine.taxes) {
                // console.log("145 - tax=", tax);

                const item = {
                  id: tax.id,
                  taxLabel: "",
                  taxTaux: 0,
                  taxType: "ENCAISSEMENT",
                  // date: null,
                  paymentDate: null,
                  invoperationDateoiceDate: null,
                  baseHT: 0.0,
                  amount: 0.0,
                  invoiceId: null,
                  expenseId: null,
                  bankTransactionId: null,
                  tiers: null
                  // category: null
                };

                commonBaseHT = FIXED2(ecritureLine.amount * -1);

                const atom = {
                  label: tax.label,
                  mode: tax.mode,
                  missing: 0
                }
                mapMissingTax.set(tax.label, atom);

                const taxTxt = tax.label + "%" + tax.valuePourcent;
                let savedItem = mapItems.get(taxTxt);

                item.invoiceId = element.node.invoice.id;
                item.tiers = element.node.invoice.tiersClient;

                if (savedItem === undefined) {
                  item.taxLabel = tax.label;
                  item.taxTaux = tax.valuePourcent;
                  item.taxType = tax.mode;
                  item.baseHT = FIXED2(ecritureLine.amount * -1);
                  // item.category = tax.category.id;
                  // item.category =

                  // if (
                  //   tax.mode === "DEBIT" ||
                  //   element.node.dateLettrage === null
                  // ) {
                  //   item.date = element.node.dateOperation;
                  // } else {
                  //   item.date = element.node.dateLettrage;
                  // }
                  item.paymentDate = dateLettrage;
                  item.operationDate = element.node.dateOperation;
                } else {
                  item.taxLabel = savedItem.taxLabel;
                  item.taxTaux = savedItem.taxTaux;
                  item.taxType = savedItem.taxType;
                  //item.date = savedItem.date;
                  item.paymentDate = savedItem.paymentDate;
                  item.operationDate = savedItem.operationDate;
                  item.amount = savedItem.amount;
                  item.invoiceId = savedItem.invoiceId;
                  item.expenseId = savedItem.expenseId;
                  item.bankTransactionId = savedItem.bankTransactionId;
                  // item.category = savedItem.category;

                  item.baseHT =
                    savedItem.baseHT + FIXED2(ecritureLine.amount * -1);
                }
                // console.log(" =>    taxTxt(2)=", taxTxt, item);
                mapItems.set(taxTxt, item);
              }

              if (
                ecritureLine.category.ids !== "ids_clients" &&
                ecritureLine.category.ids !== "ids_avancesEtAcomptesClient"
              ) {

                // console.log("167 - mapMissingTax=", mapMissingTax);
                for (const missingTax of mapMissingTax) {

                  // console.log("169 - missingTax=", missingTax);
                  if (missingTax[1].missing === 1) {

                    // console.log(" ----> missing tax", missingTax[0]);

                    if (ecritureLine.taxes.length === 0)
                      commonBaseHT = FIXED2(ecritureLine.amount * -1);

                    const item = {
                      id: null,
                      taxLabel: "",
                      taxTaux: 0,
                      taxType: "ENCAISSEMENT",
                      // date: null,
                      paymentDate: null,
                      operationDate: null,
                      baseHT: 0.0,
                      amount: 0.0,
                      invoiceId: null,
                      expenseId: null,
                      bankTransactionId: null,
                      tiers: null
                    };

                    // console.log("192 - mapItems=", mapItems);

                    const taxTxt = missingTax[0] + "%0";
                    let savedItem = mapItems.get(taxTxt);

                    item.invoiceId = element.node.invoice.id;
                    item.tiers = element.node.invoice.tiersClient;

                    if (savedItem === undefined) {
                      item.taxLabel = missingTax[0];
                      item.taxTaux = 0;
                      item.taxType = "ENCAISSEMENT";
                      item.baseHT = FIXED2(commonBaseHT);

                      // if (
                      //   missingTax[1].mode === "DEBIT" ||
                      //   element.node.dateLettrage === null
                      // ) {
                      //   item.date = element.node.dateOperation;
                      // } else {
                      //   item.date = element.node.dateLettrage;
                      // }
                      item.paymentDate = dateLettrage;
                      item.operationDate = element.node.dateOperation;
                    } else {
                      item.taxLabel = savedItem.taxLabel;
                      item.taxTaux = savedItem.taxTaux;
                      item.taxType = savedItem.taxType;
                      // item.date = savedItem.date;
                      item.paymentDate = savedItem.paymentDate;
                      item.operationDate = savedItem.operationDate;
                      item.amount = savedItem.amount;
                      item.invoiceId = savedItem.invoiceId;
                      item.expenseId = savedItem.expenseId;
                      item.bankTransactionId = savedItem.bankTransactionId;

                      item.baseHT =
                        savedItem.baseHT + FIXED2(ecritureLine.amount * -1);
                    }
                    // console.log(" =>    taxTxt(3)=", taxTxt, item);
                    mapItems.set(taxTxt, item);
                  }
                }
              }

              if (ecritureLine.category.ids === "ids_avancesEtAcomptesClient") {
                acompteBaseHT = FIXED2(ecritureLine.amount * -1);
                console.log("281 -  acompteBaseHT=", acompteBaseHT);
              }
            }
          }
          // console.log("TAX INVOICE amount=", mapItems);

          for (const item of mapItems.values()) {
            data.push(item);
          }
        }

        // ---------------------------------------------------------------------------------------
      } else if (element.node.expense) {
        const mapItems = new Map();
        let commonBaseHT = 0.0;

        // console.log("EXPE=", element.node.expense);
        let dateLettrage = element.node.dateLettrage;
        for (const ecritureLine of element.node.expense.ecritureLines) {
          if (ecritureLine.dateLettrage !== null)
            dateLettrage = ecritureLine.dateLettrage;
        }

        if (dateLettrage !== null) {

          for (const ecritureLine of element.node.expense.ecritureLines) {

            if (expenseEcritureLinesDoneArray.includes(ecritureLine.id))
              continue;

            // console.log("46 - add=", ecritureLine.id);
            expenseEcritureLinesDoneArray.push(ecritureLine.id);

            if (
              ecritureLine.category.ids ===
              "ids_taxesDeductiblesSurBiensEtServices" ||
              ecritureLine.category.ids === "ids_taxesSurVentes"
            ) {
              const item = {
                id: ecritureLine.id,
                taxLabel: "",
                taxTaux: 0,
                // date: null,
                paymentDate: null,
                operationDate: null,
                baseHT: 0.0,
                amount: 0.0,
                invoiceId: null,
                expenseId: null,
                bankTransactionId: null,
                category: null,
                tiers: null
              };

              const taxTxt =
                ecritureLine.taxes[0].label +
                "%" +
                ecritureLine.taxes[0].valuePourcent;
              let savedItem = mapItems.get(taxTxt);

              item.expenseId = element.node.expense.id;
              item.tiers = element.node.expense.tiers;

              if (savedItem === undefined) {
                item.taxLabel = ecritureLine.taxes[0].label;
                item.taxTaux = ecritureLine.taxes[0].valuePourcent;
                item.amount = FIXED2(ecritureLine.amount * -1);
                item.category = ecritureLine.category;

                // if (
                //   ecritureLine.taxes[0].mode === "DEBIT" ||
                //   element.node.dateLettrage === null
                // ) {
                //   item.date = element.node.dateOperation;
                // } else {
                //   item.date = element.node.dateLettrage;
                // }

                item.paymentDate = dateLettrage;
                item.operationDate = element.node.dateOperation;
              } else {
                item.taxLabel = savedItem.taxLabel;
                item.taxTaux = savedItem.taxTaux;
                // item.date = savedItem.date;
                item.paymentDate = savedItem.paymentDate;
                item.operationDate = savedItem.operationDate;
                item.baseHT = savedItem.baseHT;
                item.invoiceId = savedItem.invoiceId;
                item.expenseId = savedItem.expenseId;
                item.bankTransactionId = savedItem.bankTransactionId;
                item.category = savedItem.category;

                item.amount = savedItem.amount + FIXED2(ecritureLine.amount * -1);
              }
              mapItems.set(taxTxt, item);
            } else if (
              ecritureLine.category.ids !== "ids_collaborators" &&
              ecritureLine.category.ids !== "ids_suppliers"
            ) {
              commonBaseHT = commonBaseHT + FIXED2(ecritureLine.amount * -1);
            }
          }
          // console.log("TAX EXPENSE amount=", mapItems);

          for (const item of mapItems.values()) {
            item.baseHT = FIXED2(commonBaseHT);
            data.push(item);
          }
        }
      }
      else if (element.node.bankTransaction) {

        const mapItems = new Map();
        let commonBaseHT = 0.0;

        // console.log("430 - bankTransaction=", element.node.bankTransaction);
        let dateLettrage = element.node.dateLettrage;
        for (const ecritureLine of element.node.bankTransaction.ecritureLines) {
          if (ecritureLine.dateLettrage !== null)
            dateLettrage = ecritureLine.dateLettrage;
        }

        if (true || dateLettrage !== null) {

          for (const ecritureLine of element.node.bankTransaction.ecritureLines) {

            if (bankTransactionEcritureLinesDoneArray.includes(ecritureLine.id))
              continue;

            // console.log("46 - add=", ecritureLine.id);
            bankTransactionEcritureLinesDoneArray.push(ecritureLine.id);

            if (
              ecritureLine.category.ids ===
              "ids_taxesDeductiblesSurBiensEtServices" ||
              ecritureLine.category.ids === "ids_taxesSurVentes"
            ) {
              const item = {
                id: ecritureLine.id,
                taxLabel: "",
                taxTaux: 0,
                taxType: "ENCAISSEMENT",
                // date: null,
                paymentDate: null,
                operationDate: null,
                baseHT: 0.0,
                amount: 0.0,
                invoiceId: null,
                expenseId: null,
                bankTransactionId: null,
                category: null,
                tiers: null
              };

              const taxData = findTaxDataFromBankTransactionEcritureLine(element.node.bankTransaction, ecritureLine);

              //const taxTxt = ecritureLine.taxes[0].label + "%" + ecritureLine.taxes[0].valuePourcent;
              const taxTxt = taxData.label + "%" + taxData.valuePourcent;
              // console.log("491 - taxTxt=", taxTxt);
              let savedItem = mapItems.get(taxTxt);

              item.bankTransactionId = element.node.bankTransaction.id;
              // item.tiers = element.node.expense.tiers;

              // console.log("503 - element.node=", element.node);

              if (savedItem === undefined) {

                const tiers = {
                  id: "fakeID",
                  name: element.node.bankTransaction.bankAccount && element.node.bankTransaction.bankAccount.name || ""
                }
                // item.taxLabel = ecritureLine.taxes[0].label;
                // item.taxTaux = ecritureLine.taxes[0].valuePourcent;
                item.taxLabel = taxData.label;
                item.taxTaux = taxData.valuePourcent;

                item.amount = FIXED2(ecritureLine.amount * -1);
                item.category = ecritureLine.category;
                item.paymentDate = element.node.dateOperation;
                item.operationDate = element.node.dateOperation;
                item.baseHT = taxData.valueHT;
                item.tiers = tiers;

              } else {

                item.taxLabel = savedItem.taxLabel;
                item.taxTaux = savedItem.taxTaux;
                // item.date = savedItem.date;
                item.paymentDate = savedItem.paymentDate;
                item.operationDate = savedItem.operationDate;
                item.baseHT = taxData.valueHT; // savedItem.baseHT;
                item.invoiceId = savedItem.invoiceId;
                item.expenseId = savedItem.expenseId;
                item.bankTransactionId = savedItem.bankTransactionId;
                item.category = savedItem.category;
                item.tiers = savedItem.tiers;

                item.amount = savedItem.amount + FIXED2(ecritureLine.amount * -1);
              }
              mapItems.set(taxTxt, item);

            } else if (
              ecritureLine.category.ids !== "ids_collaborators" &&
              ecritureLine.category.ids !== "ids_suppliers"
            ) {
              commonBaseHT = commonBaseHT + FIXED2(ecritureLine.amount * -1);
            }
          }
          // console.log("TAX EXPENSE amount=", mapItems);

          for (const item of mapItems.values()) {
            // item.baseHT = FIXED2(commonBaseHT);
            data.push(item);
          }
        }
      }

    }
    // console.log("368 - data=", data);

    return {
      //periodCategory: mapPeriodeCategory,
      tabData: data
    };
  }
};

export default ChartsTaxesDataCompute;